// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import { onIntersection } from './utils/sticky-nav.js';
// import { activateDropdown } from './utils/dropdown.js';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// packages
import { index } from 'd3-array';

// local
import { LA_COUNTY_URL, DA_URL, EMBED_URL, STATE_URL } from './constants.js';

import { createFeed, createRaceFeed, indexByApId } from './stores.js';
import { renderSvelteComponent } from './utils/render.js';

//components
import Results from './components/Results.svelte';
import LocalResults from './components/LocalResults.svelte';
import Watching from './components/Watching.svelte';
// import PendingResultsModalLA from './components/PendingResultsModalLA.svelte';
import AtAGlanceContainer from './components/AtAGlanceContainer.svelte';
import DataTime from './components/DataTime.svelte';

const crosswalk = index(window.CROSSWALK, indexByApId);

async function main() {
  // raw feed
  const feed = await createFeed(LA_COUNTY_URL);
  const apfeed = await createFeed(DA_URL);
  const daFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(apfeed, 'CA-D82127-2024-03-05')
  );

  renderSvelteComponent(
    Results,
    /** @type {HTMLElement} */ (document.getElementById('District-Attorney')),
    {
      race: daFeed,
      face: true,
      crosswalk,
      captionNote:
        'A candidate can win by getting a majority of the vote. <br/>If no one receives 50% + 1, the top two advance to November election.',
    }
  );

  const racesOnPage = document.querySelectorAll('.race-result');
  /**  @type {import('./types.d').RaceFeed}  */

  for (let idx = 0; idx < racesOnPage.length; idx++) {
    const target = racesOnPage[idx];
    const id = target.id;

    const race = /**  @type {import('./types.d').RaceFeed}  */ (
      createRaceFeed(feed, id)
    );

    renderSvelteComponent(
      LocalResults,
      /** @type {HTMLElement} */ (document.getElementById(id)),
      { race: race }
    );
  }

  //AT A GLANCE DA AND HLA
  const atAGlanceRaces = [
    {
      race: 'district-attorney',
      id: 'CA-D82127-2024-03-05',
      label: 'District Attorney',
      feed: apfeed,
    },
    {
      race: 'hla',
      id: '1266',
      label: 'Los Angeles City Measure HLA',
      feed: feed,
    },
  ];

  atAGlanceRaces.forEach((r) => {
    r['store'] = /** @type {import('./types.d').ReadableRace} */ (
      createRaceFeed(r['feed'], r['id'])
    );
  });

  renderSvelteComponent(
    AtAGlanceContainer,
    /** @type {HTMLElement} */
    (document.getElementById('aag-container')),
    {
      races: atAGlanceRaces,
      crosswalk,
      page: 'la',
    }
  );

  // // RACES WE ARE WATCHING
  const embedFeed = await createFeed(EMBED_URL);
  const watchingRace = document.querySelectorAll('.watching');

  for (let idx = 0; idx < watchingRace.length; idx++) {
    const t = watchingRace[idx];
    const watching_el_id = t.id;
    const watching_id = watching_el_id.replace('w-', '');
    const watchingFeed = /**  @type {import('./types.d').RaceFeed}  */ (
      createRaceFeed(embedFeed, watching_id)
    );

    let targetID = 'w-' + watching_id;

    renderSvelteComponent(
      Watching,
      /** @type {HTMLElement} */ (document.getElementById(watching_el_id)),
      { race: watchingFeed }
    );
  }

  renderSvelteComponent(
    DataTime,
    /** @type {HTMLElement} */
    (document.getElementById('updated')),
    {
      race: feed,
    }
  );
}

main().catch(console.error);

// dropdown select
function filterDropdown(e, section) {
  // value of dropdown
  let value = e.target.value;
  // get the class for the elements we want
  let itemClass;
  if (section == 'cities') {
    itemClass = '.city-race-result-item';
  } else if (section == 'school-boards') {
    itemClass = '.schools-race-result-item';
  }
  // select all Elements that match
  let findItems = document.querySelectorAll(itemClass);
  // filter!
  findItems.forEach((e) => {
    if (value == 'show_all') {
      e.parentElement.classList.remove('hidden');
      e.parentElement.setAttribute('aria-hidden', 'false');
      e.classList.remove('hidden');
      e.setAttribute('aria-hidden', 'false');
    } else if (e.classList.contains(value)) {
      if (value == 'item-los-angeles' && section == 'cities') {
        // this is b/c l.a. is in a diff container
        e.parentElement.classList.remove('hidden');
        e.parentElement.setAttribute('aria-hidden', 'false');
      }
      e.classList.remove('hidden');
      e.setAttribute('aria-hidden', 'false');
    } else {
      if (value == 'item-los-angeles' && section == 'cities') {
        // this is b/c l.a. is in a diff container
        e.parentElement.classList.add('hidden');
        e.parentElement.setAttribute('aria-hidden', 'false');
      }
      e.classList.add('hidden');
      e.setAttribute('aria-hidden', 'true');
    }
  });
}

// city races
let cityDropdown = document.querySelector('select.cities');
cityDropdown.addEventListener('change', (event) =>
  filterDropdown(event, 'cities')
);
// school board races
let schoolsDropdown = document.querySelector('select.school-boards');
schoolsDropdown.addEventListener('change', (event) =>
  filterDropdown(event, 'school-boards')
);
